import "./ToiletRepair.module.css";
import Header from "@/reusable_sections/Header";
import ToiletHero from "./sections/ToiletHero";
import ToiletDiagnostics from "./sections/ToiletDiagnostics";
import ServicesTriage from "./sections/ServicesTriage";
import ToiletFaq from "./sections/ToiletFaq";
import Footer from "@/reusable_sections/Footer";
export default function ToiletRepairPage() {
  return <div>
      <Header />
      <ToiletHero />
      <ToiletDiagnostics />
      <ServicesTriage />
      <ToiletFaq />
      <Footer />
    </div>;
}